import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Station } from '../../../../../client/model/station';
import { LoadingZoneReference } from '../../../../../client/model/station-usage.model';

@Component({
    selector: 'app-loading-zone-selection',
    templateUrl: './loading-zone-selection.component.html',
    styleUrls: ['./loading-zone-selection.component.scss'],
    standalone: false
})
export class LoadingZoneSelectionComponent implements OnInit {

  station: Station;

  selected: LoadingZoneReference;

  constructor(
    private dialog: MatDialogRef<LoadingZoneSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.station = data.station;

  }

  setSelected(loadingZone: LoadingZoneReference) {
    this.selected = loadingZone;
  }

  ngOnInit(): void {
  }

  confirm() {
    this.dialog.close(this.selected);
  }

  close() {
    this.dialog.close(null);
  }

}
